<div class="header">
   <p>Pago de regalías</p>
   <img (click)="close()" class="my-auto cursor-pointer" height="13" src="assets/icon/x.svg" alt="close">
</div>

<div class="body fs-body animated fadeIn">

   <div *ngIf="!showCalculate && actualStatus === 'paid'">
      <div class="animated fadeIn bg-info-pay mt-2 mb-3">
         <p class="bg-success-pay fw-bold fs-15 mb-5">
            Regalias pagadas con éxito
         </p>
         <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="col-5 ms-3">
               <h3 class="cl-black fw-bold fs-20">Regalía por pagar</h3>
               <p class="cl-primary fw-bold fs-16">
                  {{ infoCalculate?.message }}
               </p>

               <h4 class="cl-black fs-18 fw-bold">CLABE Monific</h4>
               <p class="cl-primary fw-bold fs-14">
                  {{project?.clabe}}
               </p>

               <button mat-button class="mt-3" (click)="close()">Aceptar</button>

            </div>
            <div class="p-3 bg-black col-4 me-3">
               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Saldo al corte</h4>
                  <p class="fw-bold fs-14 m-0 text-white">{{ 0 | currency: 'MXN' }} <small>MXN</small></p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Saldo en cuenta</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{walletInfo?.balance | currency: 'MXN'}} <small>MXN</small></p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Fecha de movimiento</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{ infoCalculate.lastUpdate | date: 'YYYY-MM-dd'}}</p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Fecha limite de pago</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{project?.nextDist}}</p>
               </div>


            </div>
         </div>

      </div>
   </div>

   <div *ngIf="!showCalculate && actualStatus === null || actualStatus === undefined">
      <h3 class="ms-3 cl-black fw-bold">Pago de regalias</h3>
      <hr>
      <p class="fs-13 ms-3">Ingresa el monto de ingresos generados por el inmueble para calcular el monto estimado a pagar
         de rendimientos</p>
      <p class="fs-13 m-0 ms-3">Recuerda que el periodo corresponde al mes de:
         <strong>{{ lastMonth | date: 'MMMM YYYY' | titlecase }}</strong></p>

      <form [formGroup]="formPay" class="d-block m-auto px-3 animated fadeIn">
         <div class="d-flex align-items-center justify-content-between mt-4">
            <div>
               <label class="mnf-label">Ingresos totales</label>

               <div class="mnf-control mb-1">
                  <input type="text" currencyMask formControlName="totalWin" placeholder="$ 4,000,00.00"
                     class="mnf-input-form">
               </div>
            </div>
         </div>
      </form>


      <div class="text-center mb-3 mt-5" *ngIf="!showCalculate">
         <button mat-button [disabled]="formPay.invalid" (click)="calculateToPay()">Continuar</button>
      </div>

   </div>

   <div class="animated fadeIn px-3" *ngIf="showCalculate">
      <h3 class="cl-black fw-bold">Pago de regalias</h3>
      <hr>
      <div class="animated fadeIn bg-info-pay mt-2 mb-3">
         <div class="d-flex align-items-center justify-content-between mt-3">
            <div class="col-5 ms-3">
               <h3 class="cl-black fw-bold fs-20">Regalía por pagar</h3>
               <p class="cl-primary fw-bold fs-16">
                  {{ infoCalculate?.message }}
               </p>

               <h4 class="cl-black fs-18 fw-bold">CLABE Monific</h4>
               <p class="cl-primary fw-bold fs-14">
                  {{walletInfo?.clabe}}
               </p>

            </div>
            <div class="p-3 bg-black col-4 me-3">
               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Saldo al corte</h4>
                  <p class="fw-bold fs-14 m-0 text-white">{{ infoCalculate?.royaltyToPay | currency: 'MXN' }} <small>MXN</small></p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Saldo en cuenta</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{walletInfo?.balance | currency: 'MXN'}} <small>MXN</small></p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Fecha de corte</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{ dateCut | date: 'YYYY-MM-dd'}}</p>
               </div>

               <div class="py-2">
                  <h4 class="text-white fs-12 fw-regular">Fecha limite de pago</h4>
                  <p class="text-white fw-bold fs-14 m-0">{{project?.nextDist}}</p>
               </div>


            </div>
         </div>

      </div>

      <div *ngIf="walletInfo.balance >= infoCalculate.royaltyToPay">
         <p class="fs-13 mt-4">Cuentas con saldo disponible para hacer el pago de regalías, ¿deseas utilizarlo?</p>
      </div>

      <div class="d-flex align-items-center justify-content-around py-4">
         <button mat-button (click)="close()">Pagar en otro momento</button>
         <button mat-button (click)="next()" [disabled]="walletInfo.balance < infoCalculate.royaltyToPay">Realizar pago</button>
      </div>


      <p class="fs-13 cl-black pt-4">Recuerda que siempre puedes buscar estrategias para promover tu hotel y tener
         mejores ingresos. </p>

   </div>

</div>
